import { useEffect } from "react";

import Main from "components/layouts/Main";
import ActivationPage from "components/pages/Activation";
import BacktestDcaStrategy from "components/pages/BacktestDcaStrategy";
import BacktestGridBot from "components/pages/BacktestGridBot";
import BitcoinerChallenge from "components/pages/BitcoinerChallenge";
import CompleteRegistration from "components/pages/CompleteRegistration";
import CourseDetail from "components/pages/CourseDetail";
import CreditsDashboardPage from "components/pages/Credits/CreditsDashboard";
import CreditsTransactionsPage from "components/pages/Credits/CreditsTransactions";
import CancelRecharge from "components/pages/Credits/Recharge/Cancel";
import CreditsSalePage from "components/pages/CreditsSale/CreditsSale";
import CurrencyPairs from "components/pages/CurrencyPairs";
import DashboardPage from "components/pages/Dashboard";
import DcaBotDetailPage from "components/pages/DcaBotDetail";
import EmailPreferences from "components/pages/EmailPreferences";
import EmailVerification from "components/pages/EmailVerification";
import ExitStrategy from "components/pages/ExitStrategy";
import FeaturePage from "components/pages/Feature";
import GridBotDetail from "components/pages/GridBotDetail";
import LoginPage from "components/pages/Login";
import LostPasswordPage from "components/pages/LostPassword";
import NewAffiliatePage from "components/pages/NewAffiliatePage";
import NewDcaBotPage from "components/pages/NewDcaBot";
import NewGridBot from "components/pages/NewGridBot";
import UpdateGridBot from "components/pages/NewGridBot/Update";
import NotificationsPage from "components/pages/Notifications";
import PremiumAction from "components/pages/PremiumAction";
import Pricing from "components/pages/Pricing";
import RegisterPage from "components/pages/Register";
import SetNewPasswordPage from "components/pages/SetNewPassword";
import SettingsPage from "components/pages/Settings/Settings";
import SubscriptionsPage from "components/pages/Subscription";
import TermsPage from "components/pages/Terms";
import TwoFactorAuthPage from "components/pages/TwoFactorAuth";
import WhyBitcoin from "components/pages/WhyBitcoin";
import coursesConfig from "components/pages/WhyBitcoin/config/courses";
import { useRoutes } from "react-router-dom";
import { whyBitcoinRoute } from "utils";

const getCoursesUrls = () => {
  return coursesConfig?.courses?.flatMap((course) => {
    if (course?.chapters?.length) {
      return course.chapters.map((chapter) => {
        return {
          path: whyBitcoinRoute(chapter.url),
          element: <CourseDetail />,
        };
      });
    }

    return [];
  });
};

const NextRedirect = () => {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return null;
};

const AppRoutes = () => {
  const routes = [
    {
      element: <Main />,
      children: [
        {
          path: "/login",
          element: <LoginPage />,
        },
        {
          path: "/registrace",
          element: <RegisterPage />,
        },
        {
          path: "/dashboard",
          element: <DashboardPage />,
        },
        {
          path: "/strategie/:id",
          element: <DcaBotDetailPage />,
        },
        {
          path: "/nova-strategie",
          element: <NewDcaBotPage />,
        },
        {
          path: "/upravit-strategii/:id",
          element: <NewDcaBotPage />,
        },
        {
          path: "/nova-grid-strategie",
          element: <NewGridBot />,
        },
        {
          path: "/upravit-grid-strategii/:id",
          element: <UpdateGridBot />,
        },
        {
          path: "/grid-strategie/:id",
          element: <GridBotDetail />,
        },
        {
          path: "/exit-strategie/:id",
          element: <ExitStrategy />,
        },
        {
          exact: true,
          path: "/stosaky",
          element: <CreditsDashboardPage />,
        },
        // {
        //   path: "/stosaky-akce",
        //   element: <CreditsSalePage />,
        // },
        // {
        //   path: "/premium-akce",
        //   element: <PremiumAction />,
        // },
        {
          path: "/stosaky/transakce",
          element: <CreditsTransactionsPage />,
        },
        {
          path: "/nastaveni",
          element: <SettingsPage />,
        },
        {
          path: "/predplatne",
          element: <SubscriptionsPage />,
        },
        {
          path: "/overeni-emailu",
          element: <EmailVerification />,
        },
        {
          path: "/podminky",
          element: <TermsPage />,
        },
        {
          path: "/cenik",
          element: <Pricing />,
        },
        {
          path: "/menove-pary",
          element: <CurrencyPairs />,
        },
        {
          path: "/dvoufaktorove-overeni",
          element: <TwoFactorAuthPage />,
        },
        {
          path: "/zapomenute-heslo",
          element: <LostPasswordPage />,
        },
        {
          path: "/obnova-hesla",
          element: <SetNewPasswordPage />,
        },
        {
          path: "/aktivace",
          element: <ActivationPage />,
        },
        {
          path: "/e-mailove-preference",
          element: <EmailPreferences />,
        },
        {
          path: "/backtest-grid-strategie",
          element: <BacktestGridBot />,
        },
        {
          exact: true,
          path: "/proc-bitcoin",
          element: <WhyBitcoin />,
        },
        {
          path: "/zrusit-mesicni-platbu",
          element: <CancelRecharge />,
        },
        {
          path: "/feature/:type",
          element: <FeaturePage />,
        },
        {
          path: "/backtest-dca-strategie",
          element: <BacktestDcaStrategy />,
        },
        {
          path: "/dokonceni-registrace",
          element: <CompleteRegistration />,
        },
        {
          path: "/nova-stranka-doporuceni",
          element: <NewAffiliatePage />,
        },
        {
          path: "/upravit-stranku-doporuceni/:id",
          element: <NewAffiliatePage />,
        },
        {
          path: "/vyzva-bitcoinera",
          element: <BitcoinerChallenge />,
        },
         {
          path: "/notifikace",
          element: <NotificationsPage />,
        },
        ...getCoursesUrls(),
        {
          path: "*",
          element: <NextRedirect />,
        },
      ],
    },
  ];

  return useRoutes(routes);
};

export default AppRoutes;
